import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { DetailPageTitle } from 'src/common/components/AppLayout/DetailsPage/DetailsPageTitle';
import { PageLayout } from 'src/common/components/AppLayout/PageLayout';
import { Routes } from 'src/Routes.constants';
import { RSimDetailsTabsLayout } from './RSimDetailsTabsLayout';

type RSimDetailsRoutingParams = {
  euicc?: string;
};

const RSimDetailsPageTitle = () => {
  const { t } = useTranslation();
  const { euicc } = useParams<RSimDetailsRoutingParams>();

  return (
    <DetailPageTitle
      title={`${t('rSimInventory.title')} ${euicc}`}
      rootLocation={{
        to: Routes.productsRsim,
        name: t('rSimInventory.rsimProducts'),
      }}
      currentLocationName={t('rSimInventory.rSIMDetails')}
    />
  );
};
export const RSimDetailsPageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <PageLayout title={<RSimDetailsPageTitle />}>
      <RSimDetailsTabsLayout>{children}</RSimDetailsTabsLayout>
    </PageLayout>
  );
};
